import Modal from "react-bootstrap/Modal";
import { formatCurrency } from "../../../Utils/helpers";
import { SOURCE_LABELS } from "../utils";
import moment from "moment";

export default function PayoutHistoryDetailModal({ show, onHide, batch, scheduleLabel }) {
  if (!batch) return null;

  const isFailed = batch.status === "failed";

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className="premium-cms-modal dp-payout-modal"
    >
      <Modal.Header className="cms-modal__header">
        <div className="cms-modal__header-main">
          <div className={`cms-modal__header-icon ${isFailed ? "cms-modal__header-icon--danger" : ""}`}>
            <i className={`fas ${isFailed ? "fa-times" : "fa-receipt"}`} />
          </div>
          <div>
            <Modal.Title>Payout Details</Modal.Title>
            <p className="cms-modal__subtitle">{batch.referenceId}</p>
          </div>
        </div>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>

      <Modal.Body className="cms-modal__body">
        <div className="dp-confirm-summary">
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Schedule</span>
            <strong>{batch.weekLabel || scheduleLabel}</strong>
          </div>
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Source</span>
            <span className={`dp-source-badge dp-source-badge--${batch.source || "admin_batch"}`}>
              {SOURCE_LABELS[batch.source] || SOURCE_LABELS.admin_batch}
            </span>
          </div>
          <div className="dp-confirm-summary__item">
            <span className="dp-confirm-summary__label">Status</span>
            <span className={`dp-status-badge dp-status-badge--${batch.status}`}>
              {batch.status}
            </span>
          </div>
          <div className="dp-confirm-summary__item dp-confirm-summary__item--highlight">
            <span className="dp-confirm-summary__label">Total</span>
            <strong>{formatCurrency(batch.totalAmount)}</strong>
          </div>
        </div>

        <div className="dp-history-meta">
          <span>
            <i className="far fa-calendar-alt" />
            {moment(batch.processedAt).format("MMM D, YYYY • h:mm A")}
          </span>
          <span>
            <i className="fas fa-user-shield" />
            {batch.processedBy}
          </span>
          {batch.transferId && (
            <span>
              <i className="fab fa-stripe-s" />
              {batch.transferId}
            </span>
          )}
        </div>

        {isFailed && batch.failureReason && (
          <div className="dp-confirm-warning">
            <i className="fas fa-exclamation-triangle" />
            <div>
              <strong>Failure Reason</strong>
              <p>{batch.failureReason}</p>
            </div>
          </div>
        )}

        <div className="dp-confirm-drivers">
          <h6 className="dp-confirm-drivers__title">
            {batch.driverCount === 1 ? "Driver" : "Drivers in this batch"}
          </h6>
          <ul className="dp-confirm-drivers__list">
            {batch.drivers.map((driver, idx) => (
              <li key={idx} className="dp-confirm-drivers__row">
                <div className="dp-confirm-drivers__info">
                  <span className="dp-confirm-drivers__name">{driver.name}</span>
                  <span className="dp-confirm-drivers__bank">
                    {driver.bankLast4 ? `•••• ${driver.bankLast4}` : "No bank"}
                    {driver.failed && (
                      <span className="dp-driver-failed-tag">Failed</span>
                    )}
                  </span>
                </div>
                <span className="dp-confirm-drivers__amount">
                  {formatCurrency(driver.amount)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </Modal.Body>

      <Modal.Footer className="cms-modal-footer">
        <button type="button" className="cms-btn-save" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
}
